<template>
    <el-container id="app">
        <!--<el-aside width="240px" style="overflow:unset">
            <img draggable="false" class="logo" src="static/STS-header-logo.png" alt="HARDT logo" />
        </el-aside>-->
        <el-container>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    

    export default {
        name: "globalapp",
    }
</script>

<style>
    body {
        margin: 0;
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .logo {
        height: 55px;
        user-select: none;
        margin: 5px 0;
        padding-left: 10px;
    }

    .pager {
        text-align: right;
        margin-top: 10px;
    }

    /*Custom color for disabled elements and placeholders*/
    .el-textarea.is-disabled .el-textarea__inner, .el-input.is-disabled .el-input__inner,
    .el-cascader.is-disabled .el-cascader__label {
        color: #0052cc !important;
    }

    input::-webkit-input-placeholder {
        color: #0052cc !important;
    }

    input:-moz-placeholder { /* Firefox 18- */
        color: #0052cc !important;
    }

    input::-moz-placeholder { /* Firefox 19+ */
        color: #0052cc !important;
    }

    input:-ms-input-placeholder {
        color: #0052cc !important;
    }

    textarea::-webkit-input-placeholder {
        color: #0052cc !important;
    }

    textarea:-moz-placeholder { /* Firefox 18- */
        color: #0052cc !important;
    }

    textarea::-moz-placeholder { /* Firefox 19+ */
        color: #0052cc !important;
    }

    textarea:-ms-input-placeholder {
        color: #0052cc !important;
    }

    input[type="email"]::-webkit-input-placeholder {
        color: #0052cc !important;
    }

    input[type="email"]:-moz-placeholder { /* Firefox 18- */
        color: #0052cc !important;
    }

    input[type="email"]::-moz-placeholder { /* Firefox 19+ */
        color: #0052cc !important;
    }

    input[type="email"]:-ms-input-placeholder {
        color: #0052cc !important;
    }

    .tablewithshading > .el-table__body-wrapper > table > tbody > tr.el-table__row:nth-child(even) {
        background-color: rgba(64,158,255,0.3);
    }

    .el-table .cell {
        word-break: break-word;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/globalapp/GlobalApp.vue